<script>
export default {
  model: {
    event: "change",
  },
  props: {
    options: {
      type: Array,
      default: [],
    },
  },
  computed: {
    searchText() {
      if (this.isAllChecked) {
        return "전체";
      } else {
        return this.checked.length + "개 선택됨";
      }
    },
  },
  watch: {
    options() {
      this.checked = [];
      this.checked = this.options;
    },
  },
  mounted() {
    if (this.options.length > 0) {
      const checkedCount = this.options.filter((item) => item.checked);
      if (checkedCount == 0) {
        this.isAllChecked = false;
      }
    }
  },
  data() {
    return {
      checked: [],
      isAllChecked: true,
    };
  },
  methods: {
    changed(checked) {
      this.checked = this.options
        .filter((item) => item.isChecked)
        .map((item) => item.value);
      if (this.checked.length == this.options.length) {
        this.isAllChecked = true;
      } else {
        this.isAllChecked = false;
      }
      this.$emit("change", this.checked);
    },
    changeAll(checked) {
      if (checked) {
        this.options.forEach((item) => {
          item.isChecked = true;
        });
        this.checked = this.options.map((item) => item.value);
      } else {
        this.options.forEach((item) => {
          item.isChecked = false;
        });
        this.checked = [];
      }
      this.$emit("change", this.checked);
    },
  },
};
</script>

<template>
  <b-dropdown class="checkboxDropdown">
    <template #button-content>
      <label class="buttonContentLabel">{{ searchText }}</label>
    </template>
    <b-dropdown-form class="checkboxDropdownForm">
      <div>
        <div class="dropdownCheckbox">
          <label>전체</label>
          <b-form-checkbox v-model="isAllChecked" @change="changeAll">
          </b-form-checkbox>
        </div>
      </div>
      <div class="delimiter"></div>

      <div v-for="(item, index) in options" :key="index">
        <div class="dropdownCheckbox">
          <label>{{ item.text }}</label>
          <b-form-checkbox v-model="item.isChecked" @change="changed">
          </b-form-checkbox>
        </div>
      </div>
    </b-dropdown-form>
  </b-dropdown>
</template>

<style lang="scss">
.checkboxDropdown {
  height: 100%;

  .btn-secondary {
    padding: 6px 9px 6px 12px !important;
  }

  .buttonContentLabel {
    width: calc(100% - 12px) !important;
    height: 100%;
    margin: 0;
    align-items: center;
    display: flex;
    padding: 0 !important;
    color: #b4b7bd !important;
    font-size: 15px;
  }

  button {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
  }
  .btn-secondary {
    color: #b4b7bd !important;
    background-color: transparent !important;
    border-color: #404656 !important;
  }
}

.delimiter {
  border-top: 2px solid #606571;
  height: 10px;
}

.checkboxDropdown {
  button {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 150px;
  }
  .btn-secondary {
    color: #b4b7bd !important;
    background-color: transparent !important;
    border-color: #404656 !important;
  }

  .searchInputBox {
    border-radius: 0;
    border: none;
    border-bottom: 1px solid #404656;
    width: 100% !important;
    margin-bottom: 10px;
  }

  .checkboxDropdownForm {
    width: 100%;
    height: auto;

    div {
      display: flex;
      flex-direction: column;
      width: 100%;
      align-items: center;

      .dropdownCheckbox {
        display: flex;
        flex-direction: row;
        width: 100%;
        position: relative;
        background: #283046;
        align-items: center;
        margin: 15px 0;

        .custom-control {
          position: absolute;
          width: 100%;
          z-index: 2;
        }

        .custom-control-input {
          width: 100% !important;
        }

        label {
          position: absolute;
          color: #b4b7bd;
          width: calc(100% - 30px);
          margin: 0 !important;
          padding-left: 30px;
          z-index: 1;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
}

.dropdown-menu.show {
  display: block;
  background: #283046;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-top-style: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15);
  overflow-y: auto;
  max-height: 350px;
  min-width: 160px;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/common/DropdownCheckbox.vue